import 'jquery-scrollify'
import '../plugins/scrollevent'
import FB_init from '../plugins/facebook.js'
import INSTA from '../plugins/instagram'

const [w,d] = [window,document]

const sectionScroll = () => {
  const mq = w.matchMedia( "(min-width: 901px)")
  $.scrollify({
    section:"[data-scroll-section]",
    setHeights: false,
    overflowScroll: true,
    updateHash: false,
    interstitialSection: '[data-inter-section]',
    scrollbars: true,
    touchScroll: mq.matches,
    before( i ){
      makePagination.update( i )
    },
    afterRender() {
      makePagination.init(this.section)
    }
  })
}

const calendarScroll = () => {
  const link = d.querySelector('[data-scroll-to="#calendar"]')
  link.addEventListener('click',() => {
    $.scrollify.move("#calendar");
  })
}

const scrollNav = () => {
  let sections = d.querySelectorAll('[data-scroll-section]')
  const nav_down = d.querySelector('[data-role="scroll-nav"] button[data-dir="down"]')
  const nav_up = d.querySelector('[data-role="scroll-nav"] button[data-dir="up"]')
  nav_down.addEventListener('click',() => {
    if( $.scrollify.currentIndex() + 1 < sections.length )
    $.scrollify.next()
  })
  nav_up.addEventListener('click',() => {
    if( $.scrollify.currentIndex() != 0 )
    $.scrollify.previous()
  })
}

const headerScrollWatch = () => {
  // グローバルメニューをスクロール量で表示する
  $.scrollspy({
    trigger: (w.innerHeight * 0.8),
    onBefore() {
      $('.p-header').addClass('is-firstview');
      $('.p-home-scroll-nav').addClass('is-firstview');
    },
    onAfter() {
      $('.p-header').removeClass('is-firstview');
      $('.p-home-scroll-nav').removeClass('is-firstview');
    }
  })
}

const makePagination = {
  containerClass: 'p-scroll-pagination',
  pagination : $(`<ul class="p-scroll-pagination"></ul>`)[0],
  current:0,
  init(sec){
    let sections = d.querySelectorAll( sec )
    sections = Array.prototype.slice.call( sections, 0 )
    d.body.appendChild( this.pagination )
    sections.forEach( ( val, i ) => {
      const page = $(`<li>${i}</li>`)[0]
      page.addEventListener('click', () => $.scrollify.move( i ) )
      this.pagination.appendChild( page )
    })
    d.querySelector(`.${this.containerClass} li:nth-child(${this.current + 1})`).classList.add('active')
  },
  update( i ){
    this.current = i
    $(`.${this.containerClass} li.active`).removeClass('active')
    $(`.${this.containerClass} li:eq(${i})`).addClass('active')
  }
}

const mainvisual = {
  add (filename,video) {
    let source = d.createElement('source')
    source.src = filename
    video.appendChild( source )
  },
  rand () {
    let movies = [
      [
        '/assets/mov/lenri_topA.webm',
        '/assets/mov/lenri_topA.mp4',
      ],
      [
        '/assets/mov/lenri_topB.webm',
        '/assets/mov/lenri_topB.mp4',
      ],
    ]
    let rand_ind = Math.floor( Math.random() * movies.length )
    let video = d.querySelector('[data-plugin="mainvisual"]')
    if( video ){
      video.innerHTML = ''
      movies[rand_ind].map( path => this.add( path, video ) )
    }
  }
}


export default function HOME () {

  FB_init()

  d.addEventListener('DOMContentLoaded',() => {
    calendarScroll()
    headerScrollWatch()
    scrollNav()
    mainvisual.rand()
    INSTA()
  })
  w.addEventListener('load', sectionScroll )
}